import { Link } from "@tanstack/react-router";
import { useMemo } from "react";

import CloudinaryImage from "@/components/cloudinary-image";
import ProfileCard from "@/components/profile-card";

import type { FollowerType } from "../types";

interface FollowersProps {
  followers: FollowerType[];
  followersCount: number;
}

export default function Followers({
  followers,
  followersCount,
}: FollowersProps) {
  const { count, images, users } = useMemo(() => {
    const images = [...followers]
      .sort((a, b) => {
        if (!a.imageId && !!b.imageId) {
          return 1;
        }
        if (!!a.imageId && !b.imageId) {
          return -1;
        }
        return 0;
      })
      .splice(0, 3);
    const users = [...followers].splice(0, 2);
    const count = followersCount - users.length;
    return { count, images, users };
  }, [followers, followersCount]);

  return (
    <div className="flex flex-wrap items-center gap-1 pl-2.5">
      {!!images.length &&
        images.map((follower) => (
          <CloudinaryImage
            className="-ml-2.5 size-6 rounded-full border-2 border-midnight-express bg-white"
            key={follower.id}
            rW={48}
            size={24}
            user={follower}
          />
        ))}
      <p className="shrink-0 text-12 text-white/60">followed by</p>
      <div className="flex shrink-0 gap-1.5 text-12 text-white/60">
        {users.map((follower) => (
          <ProfileCard key={follower.id} userId={follower.id}>
            <div
              className="not-first:-ml-1.5 not-first:before:content-[attr(data-separator)]"
              data-separator=", "
            >
              <Link
                className="font-medium text-white hover:underline"
                to={`/@${follower.username}`}
              >
                {follower.username}
              </Link>
            </div>
          </ProfileCard>
        ))}
      </div>
      <p className="shrink-0 text-12 text-white/60">
        {count > 0 && ` and ${count} other${count === 1 ? "" : "s"}`}
      </p>
    </div>
  );
}
